(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mldrip-sale"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mldrip-sale-countdown')) {
    customElements.define('mldrip-sale-countdown', class extends HTMLElement {
      connectedCallback() {
        this.deadline = Date.parse(this.dataset.deadline);
        if (!Number.isFinite(this.deadline)) { this.hidden = true; return; }
        this.parts = Object.fromEntries(['days', 'hours', 'minutes', 'seconds'].map(unit => [unit, this.querySelector(`[data-unit="${unit}"]`)]));
        this.updateClock();
        if (!this.hidden && !this.clockInterval) this.clockInterval = setInterval(() => this.updateClock(), 1000);
      }
      disconnectedCallback() { clearInterval(this.clockInterval); this.clockInterval = null; }
      updateClock() {
        const left = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        if (!left) { this.hidden = true; clearInterval(this.clockInterval); this.clockInterval = null; return; }
        const values = {days: Math.floor(left / 86400), hours: Math.floor(left / 3600) % 24, minutes: Math.floor(left / 60) % 60, seconds: left % 60};
        Object.entries(values).forEach(([unit, value]) => { if (this.parts[unit]) this.parts[unit].textContent = unit === 'days' ? String(value) : String(value).padStart(2, '0'); });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
